import LoadingIcon from '@polyai/ui/components/atoms/LoadingIcon';

import { ToastLoaderWrapper } from './AgentStreamContext.styled';

export const RECONNECTING_DESCRIPTION = (
  <ToastLoaderWrapper>
    <LoadingIcon size={12} /> Attempting to reconnect
  </ToastLoaderWrapper>
);
